import UserInfoWrapper from "../../pages/styles/UserInfoWrapper";


const UsersInfo = (props) => {
    const { icon, text } = props;
    return (
        <UserInfoWrapper>
            <span className="icon">{icon}</span>
            <div className="text">{text}</div>
        </UserInfoWrapper>
    )
};
export default UsersInfo;